/// <reference path="../../../node_modules/react-datetime/react-datetime.d.ts" />

import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import notify from '../../shared/feedback/notifications';
import { Modal, Button, FormGroup, FormControl, ControlLabel, Row, Col } from 'react-bootstrap';
import { handleError } from '../../shared/ErrorCatching';
import * as actions from './InvoiceActions';
import { assign } from '../../shared/Assign';
import DateTime from 'react-datetime';

class ViewCustomerInvoiceModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            invoiceId: props.invoiceId
        };
    }

    componentDidMount(): void {
        this.props.actions.get(this.state.invoiceId).catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <Modal show={true} onHide={this.props.closeModal} dialogClassName="modal-size">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('invoice/new/title')} {this.props.receiver}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={9} className="invoice-preview-column">
                                {this.props.rendered && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.rendered
                                        }}
                                    ></div>
                                )}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal} bsStyle="default">
                            {Translate('invoice/close')}
                        </Button>
                        <Button onClick={() => window.print()} bsStyle="primary">
                            {Translate('invoice/print')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        rendered: state.invoices.invoice.renderedTemplate,
        receiver: state.invoices.invoice.receiver
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            get: (invoiceId: number) => dispatch(actions.getInvoice(invoiceId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewCustomerInvoiceModal);
